import React, { useEffect, useState } from 'react';
import BlogBanner from '../../components/BlogBanner';
import BlogSection from '../../components/BlogSection';
import { getSeoByUrl } from '../../api/api';
import { Helmet } from "react-helmet-async";

const Blog = () => {
  const [seoData, setSeoData] = useState({});


  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("blog");

        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchSeoData();
  }, []);


  return (
    <div>
      <Helmet>
        <title>
          {seoData.metaTitle || "Blog | Nutrillion"}
        </title>

        <meta
          name="description"
          content={seoData.metaDescription || "Nutrition tips and DNA based diet plans"}
        />

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={seoData.canonicalUrl || "https://nutrillion.one/blog"}
        />
      </Helmet>
      <BlogBanner />
      <BlogSection />
    </div>
  );
};

export default Blog;